var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"lg:w-full bg-snowDrift pb-60 md:pb-0"},[_c(_vm.dashboardType,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }